const Tokenizer = require("./tokenizer");
class StingTokenizer extends Tokenizer {
    constructor() {
        super("string");
    }

    getToken(text, currentPos) {
        if (text[currentPos] === "'") {
            let value = '';
            let consumedChars = 0;
            consumedChars++;
            let char = text[currentPos + consumedChars];
            while (char !== "'") {
                if (char === undefined) {
                    throw new TypeError("unterminated string ");
                }
                value += char;
                consumedChars++;
                char = text[currentPos + consumedChars];
            }
            return [consumedChars + 1, {type: this.type, value: value}];
        }
        return [0, null];
    }

    parse(tokens, current) {
        return [current + 1,
            {
                type: 'StringLiteral',
                value: tokens[current].value,
                getInterpolatedValue: this.interpolateValue.bind(this, tokens[current].value),
                params: []
            }];
    }
}

module.exports = StingTokenizer;